import { useCallback } from 'react';

import { FILTER_UNITS, type PartFileUnits } from '@frontend/api';
import { SegmentControl, Segment } from '@frontend/components';

type UnitPickerProps = {
  value: PartFileUnits;
  onChange: (value: PartFileUnits) => void;
  isDisabled?: boolean;
};

export const UnitPicker = ({
  value,
  onChange,
  isDisabled = false,
}: UnitPickerProps) => {
  const handleChange = useCallback(
    (nextValue: string | React.FormEvent<HTMLDivElement>) => {
      if (
        typeof nextValue === 'string' &&
        (nextValue === FILTER_UNITS.IN || nextValue === FILTER_UNITS.MM)
      ) {
        onChange(nextValue as PartFileUnits);
      }
    },
    [onChange],
  );

  return (
    <SegmentControl
      value={value}
      onChange={handleChange}
      isDisabled={isDisabled}
      size="sm"
      className="unit-picker-control"
    >
      <Segment value={FILTER_UNITS.IN} className="unit-picker-segment-in">
        in.
      </Segment>
      <Segment value={FILTER_UNITS.MM} className="unit-picker-segment-mm">
        mm
      </Segment>
    </SegmentControl>
  );
};
